<template>
  <tr class="text-center">
    <td>
      {{ fee.reason?.name }}
    </td>
    <td>
      <div class="fw-bolder"> {{ fee.fee_with_invoice_url?.length }} </div>
    </td>
    <td> {{ $formatLocalAmount(fee?.amount) }} </td>
    <td> {{ currency }} </td>
    <td> {{ new Date(fee?.date).toLocaleDateString() }} </td>
    <td>
      <div @click.prevent="toggleShowModal" class="position-relative">
        <span class="bi bi-file-earmark fs-2 cursor-pointer">
        <span class="bdg bdg-circle badge-primary top-0 position-absolute"> {{ fee.fee_with_invoice_url?.length }} </span>
      </span>`
      </div>
    </td>
  </tr>
  <div class="modal fade" :id="'show-file-modal'+fee.id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="toggleShowModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="accordion accordion-icon-toggle" id="kt_accordion_2">
              <div class="col-12" v-for="(file, index) in fee.fee_with_invoice_url" :key="index">
                <div class="accordion-header py-3 d-flex" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_2_item_'+index">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-5"> {{ file.name }} </h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
                </div>
                <div :id="'kt_accordion_2_item_'+index" class="fs-6 collapse ps-10" :class="!index && 'show'" data-bs-parent="#kt_accordion_2">
                  <div class="w-100">
                    <object v-if="!file?.type?.startsWith('image')" :data='file.url' width="100%" height="678">
                      <iframe :src='file.url' width="500" height="678"></iframe>
                    </object>
                    <div v-else class="col-md-12 d-flex justify-content-center align-items-center">
                      <img :src="file.url" :alt="file.name" class="img" style="width: 100%; height: 600px;object-fit: contain">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <Button type="cancel" @click.prevent="toggleShowModal" id="cancel_btn" btn-class="btn-sm" size="7px 30px" btn-text="button.close"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps} from "vue";

const props = defineProps({
  fee: Object,
  index: Number,
  currency: String
})

import {$formatLocalAmount} from "@/mixins/Helpers";
import Button from "@/components/Button.vue";

const toggleShowModal = () => {
  $(`#show-file-modal${props.fee.id}`).modal('toggle')
}

</script>

<style scoped>
.bdg {
  display: inline-block;
  padding: .325rem .5rem;
  font-size: .85rem;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .325rem;
}

.bdg.bdg-circle{
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}

.bdg.bdg-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 .1rem;
  line-height: 0;
}
</style>
